// Seacom packages
export const seacomPackages = [
  // Regular Seacom Packages
  {
    ID: 3368843,
    Title: "Seacom FTTH 50/50Mbps - Seacom FTTH By Wondernet",
    Price: 899.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 51200,
    Supplier: "Seacom",
    ISP: "Wondernet"
  },
  {
    ID: 3368847,
    Title: "Seacom FTTH 100/100Mbps - Seacom FTTH By Wondernet",
    Price: 1099.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "Seacom",
    ISP: "Wondernet"
  },
  {
    ID: 22559806,
    Title: "Seacom FTTH 10/10Mbps - Seacom FTTH By Wondernet",
    Price: 599.00,
    "Download speed (kbps)": 10240,
    "Upload speed (kbps)": 10240,
    Supplier: "Seacom",
    ISP: "Wondernet"
  },
  {
    ID: 22559807,
    Title: "Seacom FTTH 25/25Mbps - Seacom FTTH By Wondernet",
    Price: 699.00,
    "Download speed (kbps)": 25600,
    "Upload speed (kbps)": 25600,
    Supplier: "Seacom",
    ISP: "Wondernet"
  },
  {
    ID: 22559821,
    Title: "Seacom 1000/200Mbps FTTH - Seacom FTTH By Wondernet",
    Price: 1499.00,
    "Download speed (kbps)": 1024000,
    "Upload speed (kbps)": 204800,
    Supplier: "Seacom",
    ISP: "Wondernet"
  },
  {
    ID: 22559832,
    Title: "Seacom FTTH 200/200Mbps - Seacom FTTH By Wondernet",
    Price: 1299.00,
    "Download speed (kbps)": 204800,
    "Upload speed (kbps)": 204800,
    Supplier: "Seacom",
    ISP: "Wondernet"
  },
  {
    ID: 22559833,
    Title: "Seacom FTTH 500/500Mbps - Seacom FTTH By Wondernet",
    Price: 1399.00,
    "Download speed (kbps)": 512000,
    "Upload speed (kbps)": 512000,
    Supplier: "Seacom",
    ISP: "Wondernet"
  },
  
  // Seacom MTB Packages
  {
    ID: 22559856,
    Title: "Seacom FTTH 25/25Mbps - Seacom MTB FTTH By Wondernet",
    Price: 449.00,
    "Download speed (kbps)": 25600,
    "Upload speed (kbps)": 25600,
    Supplier: "Seacom",
    ISP: "Wondernet"
  },
  {
    ID: 22559857,
    Title: "Seacom FTTH 50/50Mbps - Seacom MTB FTTH By Wondernet",
    Price: 757.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 51200,
    Supplier: "Seacom",
    ISP: "Wondernet"
  },
  {
    ID: 22559858,
    Title: "Seacom FTTH 100/100Mbps - Seacom MTB FTTH By Wondernet",
    Price: 927.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "Seacom",
    ISP: "Wondernet"
  },
  {
    ID: 22559859,
    Title: "Seacom FTTH 200/200Mbps - Seacom MTB FTTH By Wondernet",
    Price: 1097.00,
    "Download speed (kbps)": 204800,
    "Upload speed (kbps)": 204800,
    Supplier: "Seacom",
    ISP: "Wondernet"
  },
  {
    ID: 22559860,
    Title: "Seacom FTTH 500/500Mbps - Seacom MTB FTTH By Wondernet",
    Price: 1349.00,
    "Download speed (kbps)": 512000,
    "Upload speed (kbps)": 512000,
    Supplier: "Seacom",
    ISP: "Wondernet"
  },
  {
    ID: 22559861,
    Title: "Seacom FTTH 1000/250Mbps - Seacom MTB FTTH By Wondernet",
    Price: 1495.00,
    "Download speed (kbps)": 1024000,
    "Upload speed (kbps)": 256000,
    Supplier: "Seacom",
    ISP: "Wondernet"
  }
];